import React from "react";
import "./PartyDetail.scss";
import {MDBBox, MDBCard, MDBCardBody, MDBContainer, MDBIcon, MDBTypography} from "mdbreact";

import StockChart from "../../component/StockChart";
import KeyInfo from "../../component/KeyInfo/KeyInfo";
import NewsList from "../../component/NewsList/NewsList";
import SubPageHeader from "../../component/SubPageHeader/SubPageHeader";
import {fetchQuery} from "relay-runtime";
import environment from "../../Environment";
import PartyDetailByIdQuery from "../../queries/PartyDetailByIdQuery";
import StockList from "../../component/StockListing/StockList";
import AllNewsQuery from "../../queries/AllNewsQuery";
import PartiesList from "../../component/PartiesList/PartiesList";
import BottomNav from "../../component/BottomNav/BottomNav";
import Loading from "../../component/Loading";
import SectionHeader from "../../component/SectionHeader/SectionHeader";
import PartyPerformanceAnalysisQuery from "../../queries/PartyPerformanceAnalysisQuery";
import {assetUrl, loss_color, profit_color} from "../../serviceApi";
import StockGraph from "../../component/StockGraph/StockGraph";
import StockOwnedCountQuery from "../../queries/StockOwnedCountQuery";
import StockHistoryDetailsQuery from "../../queries/StockHistoryDetailsQuery";
import Skeleton from "react-loading-skeleton";
import AllPoliticianByPartyIdQuery from "../../queries/AllPoliticianByPartyIdQuery";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";

const PartyProfile = assetUrl + "images/BJP.png";
const GraphIcon = assetUrl + "images/graph-icon.svg";
const UserIcon = assetUrl + "images/User-icon.svg";
const PoliticalIcon = assetUrl + "images/political-icon.svg";
const PoliticalFootprintIcon = assetUrl + "images/political-footprint-icon.svg";
const NewsIcon = assetUrl + "images/news-icon.svg";
const PoliticalCareerIcon = assetUrl + "images/political-career-icon.svg";
const ArrowDown = assetUrl + "images/arrow-down-purple-sm.svg";

const initial_key_info = [
	{
		title: "President",
		value: ""
	},
	{
		title: "Headquaters",
		value: ""
	},
	{
		title: "Founded",
		value: ""
	},
	{
		title: "Presidium",
		value: ""
	}
];

class PartyDetail extends React.Component {
	state = {
		graph_filter: "2week",
		sort_by: "high-to-low",
		key_info: initial_key_info,
		//  key_info: [],
		news_list: [],
		partyId: "",
		party_detail: {},
		stock_list: [],
		similarPartyList: [],
		xAxis: [],
		yAxis: [],
		loadingArray: ["loading"],
		graph_loading: false,
		stockOwnedCount: {},
		stockHistoryDetails: []

	}

	componentWillMount() {
		this.setState({
			//         party_detail:SinglePartyDetail,
			//         stock_list:this.formateStockData(SinglePartyDetail.politicians.edges),
			//         news_list:newsList,
			//         similarPartyList: partyList,
		});
	}

	componentDidMount() {
		this.setState({
			partyId: this.props.match.params.id
		}, () => {
			this.getPartyDetail();
			this.getPartyNews();
			this.getPartyPerformance();
			if(this.props.logged_in){
				this.getStockOwnedCount();
			}
			this.getStockHistoryDetails();
			this.getPoliticianList()
		});
	}

	getStockOwnedCount = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockOwnedCountQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.stockOwnedCount !== null && Object.keys(response.stockOwnedCount).length > 0) {
					this.setState({
						stockOwnedCount: response.stockOwnedCount
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.allPoliticians.edges)
				} else {
					this.setState({
						stockOwnedCount: {}

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockOwnedCount: {}
				})
			});
	}
	getStockHistoryDetails = () => {
		let variables = {
			stockId: ""
		}
		this.updateLoading(true);
		fetchQuery(environment, StockHistoryDetailsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);

				if (response.stockHistoryDetails !== null && Object.keys(response.stockHistoryDetails).length > 0) {

					this.setState({
						stockHistoryDetails: response.stockHistoryDetails
						// stock_list:response.allPoliticians.edges.length>0 ?response.allPoliticians.edges:[]
					})
					// console.log(response.stockHistoryDetails.price_diff)
				} else {
					this.setState({
						stockHistoryDetails: []

					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					stockHistoryDetails: []
				})
			});
	}

	getPartyDetail = () => {
		let variables = {
			id: this.props.match.params.id
		}
		this.updateLoading(true);
		fetchQuery(environment, PartyDetailByIdQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.allParties !== null && response.allParties.edges.length > 0) {
					let nodeData = response.allParties.edges[0].node;
					let temp_key_info = this.state.key_info.slice();
					temp_key_info[0].value = nodeData.president;
					temp_key_info[1].value = nodeData.headquarters;
					temp_key_info[2].value = nodeData.founded;
					temp_key_info[3].value = nodeData.presidium;
					this.setState({
						party_detail: nodeData,
						key_info: temp_key_info,
						// stock_list: this.formateStockData(nodeData.politicians.edges),
						similarPartyList: nodeData.similarParties.edges
					});
				} else {
					this.setState({
						party_detail: {},
						key_info: initial_key_info,
						// stock_list: [],
						similarPartyList: []
					});
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					party_detail: {},
					key_info: initial_key_info,
					// stock_list: [],
					similarPartyList: [],

				});
			});
	}

	getPoliticianList = () => {
		let variables = {
			party: this.props.match.params.id,
			first:5
		}
		fetchQuery(environment, AllPoliticianByPartyIdQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.allPoliticians !== null && response.allPoliticians.edges.length > 0) {
					this.setState({
						stock_list: this.formateStockData(response.allPoliticians.edges),
					});
				} else {
					this.setState({
						stock_list: [],
					});
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({

					stock_list: [],

				});
			});

	}

	getPartyPerformance = () => {
		let week = 0;
		let day = 0;
		let month = 0;
		if (this.state.graph_filter === "1week") {
			week = 1;
		} else if (this.state.graph_filter === "2week") {
			week = 2;
		} else if (this.state.graph_filter === "1day") {
			day = 1;
		} else if (this.state.graph_filter === "1month") {
			month = 1;
		} else if (this.state.graph_filter === "all") {
			month = 1;
			day = 1;
			week = 1;
		}
		let variables = {
			partyId: this.state.partyId,
			weeks: week,
			days: day,
			month: month,
			all: this.state.graph_filter === "all"
		}
		this.setState({
			graph_loading: true
		})
		// this.updateLoading(true);
		fetchQuery(environment, PartyPerformanceAnalysisQuery, variables)
			.toPromise()
			.then(response => {
				this.setState({
					graph_loading: false
				})
				// this.updateLoading(false);
				if (response.partyPerformanceAnalysis !== null && response.partyPerformanceAnalysis.edges.length > 0) {
					let arrayData = response.partyPerformanceAnalysis.edges;
					let xaxis = [];
					let yaxis = [];
					if (arrayData.length === 1) {
						// let temp_xAxis = [arrayData[0].node.updatedPrice]
						// xaxis = temp_xAxis.flatMap(i=>[i,i,i,i,i])
						// let temp_yAxis = [arrayData[0].node.created]
						// yaxis = temp_yAxis.flatMap(i=>[i,i,i,i,i])
						// var nowHour = new Date(arrayData[0].node.created).getHours();
						// for(var i = 0; i < nowHour ; i++){
						//     let date = new Date(new Date(arrayData[0].node.created).getTime() - (1000*60*(60*i)));
						//     xaxis.push(date.toISOString());
						//     yaxis.push(arrayData[0].node.updatedPrice);
						// }
						var nowHour = new Date(arrayData[0].node.created).getHours();
						var startDate = new Date(arrayData[0].node.created);
						startDate.setDate(startDate.getDate() - 1);
						for (var i = 0; i < nowHour; i++) {
							let date = new Date(new Date(arrayData[0].node.created).getTime() - (1000 * 60 * (60 * i)));
							if (date.getDate() > startDate.getDate()) {
								xaxis.push(date);
								yaxis.push(arrayData[0].node.updatedPrice);
							}
						}
						// console.log(xaxis);

					} else {
						for (var i = 0; i < arrayData.length; i++) {
							yaxis[i] = arrayData[i].node.updatedPrice;
							xaxis[i] = arrayData[i].node.created;
							// console.log(new Date(arrayData[i].node.created));
						}
					}

					this.setState({
						xAxis: xaxis,
						yAxis: yaxis
					})
				} else {
					this.setState({
						xAxis: [],
						yAxis: []
					})
				}
			}, err => {
				// this.updateLoading(false);
				this.setState({
					xAxis: [],
					yAxis: [],
					graph_loading: false
				})
			});
	}

	filterGraph = (data) => {
		this.setState({
			graph_filter: data,
			xAxis: [],
			yAxis: []
		}, () => {
			this.getPartyPerformance();
		});
	}

	formateStockData = (response) => {
		let stockList = [];
		let res_data = response;
		for (var i = 0; i < res_data.length; i++) {
			stockList[i] = {
				id: res_data[i].node.id,
				name: res_data[i].node.name,
				party_name: res_data[i].node.party.partyName,
				price: res_data[i].node.price,
				//stockOwned change
				// stocks_owned:res_data[i].node.stockOwnedCount,
				price_diffrence: res_data[i].node.priceDiffPercentage,
				politicianImage: res_data[i].node.politicianImage
			}
		}
		return stockList;
	}

	getPartyNews = () => {
		let variables = {
			party: this.state.partyId
		}
		this.updateLoading(true);

		fetchQuery(environment, AllNewsQuery, variables)
			.toPromise()
			.then(response => {
				this.updateLoading(false);
				if (response.allNews !== null && response.allNews.edges.length > 0) {
					this.setState({
						news_list: response.allNews.edges
					})
				} else {
					this.setState({
						news_list: []
					})
				}
			}, err => {
				this.updateLoading(false);
				console.log(err);
				this.setState({
					news_list: []
				})
			});
	}

	updateLoading = (action) => {
		let tmp_loading_array = this.state.loadingArray;
		if (action) {
			tmp_loading_array.push("loading");
		} else {
			tmp_loading_array.pop();
		}
		this.setState({
			loadingArray: tmp_loading_array
		})
	}

	render() {
		const {party_detail} = this.state;
		// let shortlist_politician = []
		// for (let i=0;i<party_detail.politician.length;i++){
		// 	if(i<5){
		// 		shortlist_politician.push(party_detail.politician[i])
		// 	}
		//
		// }

		if (this.state.sort_by === "high-to-low") {
			this.state.stock_list.sort((a, b) => b.price - a.price)
		} else {
			this.state.stock_list.sort((a, b) => a.price - b.price)
		}
		return (
			// <Loading loading={this.state.loadingArray.length > 1}>
			<div className="party-detail-component">
				{/*header */}
				<SubPageHeader title="Details" show_action={true}/>
				<div className={"main-section"}>
					{/*party  detail*/}
					<MDBBox className="party-detail-section d-flex align-items-center">
						{
							Object.keys(party_detail).length < 1 ?
								<Skeleton circle={true} height={"56px"} width={"56px"}/>
								:
								<img src={party_detail.partyImage ? party_detail.partyImage : PartyProfile}
								     alt="PartyProfile" className="img-fluid"
								     style={{width: "56px", height: "56px", objectFit: "contain"}}/>
						}
						{
							Object.keys(party_detail).length < 1 ?
								<div className={'d-flex flex-column ml-3'}>
									<Skeleton width={'100px'} style={{marginBottom: "8px"}}/>

									<Skeleton width={'100px'} style={{marginBottom: "8px"}}/>
								</div>

								:
								<MDBBox className="party-description">

									<MDBTypography tag="p" className="font-weight-bold party-name">
										{party_detail.partyName}
									</MDBTypography>
									<MDBBox className="d-flex align-items-center">
										{
											party_detail.priceDiffPercentage >= 0 ?
												<MDBIcon icon="caret-up" className="color-icon"/>
												:
												<MDBIcon icon="caret-down" className="color-icon"
												         style={{color: loss_color}}
												/>
										}

										<MDBTypography
											tag="p"
											className="party-stock-value"
											style={{color: party_detail.priceDiffPercentage >= 0 ? profit_color : loss_color}}
										>
											{party_detail.priceDiffPercentage}%
										</MDBTypography>

									</MDBBox>
								</MDBBox>}
					</MDBBox>
					{/* politicians list */}
					<MDBBox className="party-detail-count-section d-flex align-items-center">
						{
							Object.keys(party_detail).length < 1 ?
								<Skeleton width={'180px'} style={{marginBottom: "8px"}}/>
								:
								<MDBTypography tag="p" className="party-detail-count-label">Total Politicians Listed :
									<span>{party_detail.politicianCount ? party_detail.politicianCount : 0}</span>
								</MDBTypography>}
						<MDBBox className="horizontal-line"/>
						{
							Object.keys(party_detail).length < 1 ?
								<Skeleton width={'100px'} style={{marginBottom: "8px"}}/>
								:
								<MDBTypography tag="p" className="party-detail-count-label">Total MLA :
									<span>{party_detail.mlaCount ? party_detail.mlaCount : 0}</span>
								</MDBTypography>}
					</MDBBox>

					<MDBBox className="stock-graph-section">

						{party_detail.stocksOwned !== 0 && Object.keys(party_detail).length > 0 &&
						<MDBBox className="d-flex align-items-center stock-own-section">
							<img alt={"alt"} src={GraphIcon} alt="GraphIcon" className="img-fluid  graph-icon"/>
							<div className={"d-flex stock-own-content-content"}>
								<span className={"stock-own-count"}>{party_detail.stocksOwned}</span>
								<MDBTypography tag="p" className="stock-own-text">Shares owned</MDBTypography>
							</div>
						</MDBBox>}

						<MDBBox style={{backgroundColor: "#f5f3fb47", borderRadius: "8px"}}
						        className={"graph-wrapper"}>
							{
								this.state.graph_loading ?
									<Skeleton height={"200px"} width={"100%"}/>
									:
									<StockGraph curve={"smooth"}
									            color={"#AB8EF5"}
									            xaxis={this.state.xAxis}
									            yaxis={this.state.yAxis}
									            graph_filter={this.state.graph_filter}
									            sparkline={false}
									            graph_loading={this.state.graph_loading}
									/>}
							<MDBBox
								className="d-flex align-items-center justify-content-around graph-filter-container">
								<MDBBox
									className={this.state.graph_filter === "1day" ? "graph-filter-text active" : "graph-filter-text"}
									onClick={() => this.filterGraph("1day")}
								>
									1 Day
								</MDBBox>
								<MDBBox
									className={this.state.graph_filter === "1week" ? "graph-filter-text active" : "graph-filter-text"}
									onClick={() => this.filterGraph("1week")}
								>
									1 Week
								</MDBBox>
								<MDBBox
									className={this.state.graph_filter === "2week" ? "graph-filter-text active" : "graph-filter-text"}
									onClick={() => this.filterGraph("2week")}
								>
									2 Weeks
								</MDBBox>
								<MDBBox
									className={this.state.graph_filter === "1month" ? "graph-filter-text active" : "graph-filter-text"}
									onClick={() => this.filterGraph("1month")}
								>
									1 Month
								</MDBBox>
								<MDBBox
									className={this.state.graph_filter === "all" ? "graph-filter-text active" : "graph-filter-text"}
									onClick={() => this.filterGraph("all")}
								>
									All
								</MDBBox>
							</MDBBox>
						</MDBBox>

					</MDBBox>

					<MDBBox className="politician-list-section">
						<SectionHeader heading={"Politicians"} image={PoliticalIcon} viewmore={true}
						               redirect={"/all-stocks"} party_filter={party_detail}/>
						<MDBBox className="filter-section">
							<div className="select-dropdown d-flex align-items-center">
								<label className="m-0">Price: </label>
								<select value={this.state.sort_by} onChange={(e) => {
									this.setState({
										sort_by: e.target.value
									});
								}}>
									<option value="high-to-low">High to Low</option>
									<option value="low-to-high">Low to High</option>
								</select>
								<img src={ArrowDown} alt={"ArrowDown"} className={"ml-2"}/>
							</div>
						</MDBBox>
						<div className={"stock-section"}>
							{this.state.stock_list.length > 0 ?
								<StockList stock_list={this.state.stock_list}
								           stock_history_details={this.state.stockHistoryDetails}
								           stock_owned_count={this.state.stockOwnedCount}/>
								:
								<div style={{marginBottom: "24px"}}>
									<Skeleton count={5} height={"50px"}/>
								</div>}
						</div>
					</MDBBox>

					{
						Object.keys(party_detail).length > 0 &&
						<KeyInfo key_info={this.state.key_info}/>
					}

					<MDBBox className="political-footprint-section ">
						<MDBBox className="d-flex justify-content-between align-items-center">
							<MDBBox className="d-flex align-items-center">
								<img src={PoliticalFootprintIcon} alt="HomeIcon"/>
								<MDBTypography tag="p" className="political-footprint-title">Political
									Footprint</MDBTypography>
							</MDBBox>
							{/*<select className="form-control" >*/}
							{/*    <option>All India</option>*/}
							{/*    /!*<option>2</option>*!/*/}
							{/*    /!*<option>3</option>*!/*/}
							{/*    /!*<option>4</option>*!/*/}
							{/*    /!*<option>5</option>*!/*/}
							{/*</select>*/}
						</MDBBox>

						<MDBBox className="d-flex" style={{margin: "24px 0"}}>
							<MDBCard className="w-100"
							         style={{boxShadow: "none", border: "1px solid #E5E5E5", borderRadius: "8px"}}>
								<MDBCardBody className="member-card-body">
									<MDBBox className="d-flex member-count-section">
										<img src={UserIcon} alt="UserIcon" className="img-fluid"/>
										{
											Object.keys(party_detail).length < 1 ?
												<Skeleton width={"40px"}/>
												: <MDBTypography tag="p"
												                 className="footprint-count">{party_detail.lokSabhaMembers}</MDBTypography>
										}

									</MDBBox>
									<div className={"d-flex"}>
										<MDBTypography tag="p" className="footprint-name">Lok Sabha </MDBTypography>
										<MDBTypography tag="p" className="footprint-name ml-1"
										               style={{fontWeight: 300}}>Members</MDBTypography>
									</div>
								</MDBCardBody>
							</MDBCard>

							<div style={{width: "14px"}}/>
							<MDBCard className="w-100"
							         style={{boxShadow: "none", border: "1px solid #E5E5E5", borderRadius: "4px"}}>
								<MDBCardBody className="member-card-body">
									<MDBBox className="d-flex member-count-section">
										<img src={UserIcon} alt="UserIcon" className="img-fluid"/>
										{
											Object.keys(party_detail).length < 1 ?
												<Skeleton width={"40px"}/>
												: <MDBTypography tag="p"
												                 className="footprint-count">{party_detail.rajyaSabhaMembers}</MDBTypography>}
									</MDBBox>
									<div className={"d-flex"}>
										<MDBTypography tag="p" className="footprint-name">Rajya
											Sabha</MDBTypography>
										<MDBTypography tag="p" className="footprint-name ml-1"
										               style={{fontWeight: 300}}>Members</MDBTypography>

									</div>
								</MDBCardBody>
							</MDBCard>
						</MDBBox>
					</MDBBox>

					{/*<MDBBox className="recent-tweet-list-section py-3">*/}
					{/*    <MDBBox className="d-flex justify-content-between align-items-center">*/}
					{/*        <MDBBox className="d-flex align-items-center">*/}
					{/*            <div className=" mr-3 icon-section">*/}
					{/*                <img src={TwitterIcon} alt="TwitterIcon"  width="20px"/>*/}
					{/*            </div>*/}
					{/*            <MDBTypography tag="p" className="m-0 tweet-title">Recent Tweets</MDBTypography>*/}
					{/*        </MDBBox>*/}
					{/*        <a className="view-all-text ">View All <MDBIcon icon="angle-right" className="ml-2"/></a>*/}
					{/*    </MDBBox>*/}
					{/*    <MDBBox className="mt-3">*/}
					{/*        <TweetList/>*/}
					{/*    </MDBBox>*/}
					{/*</MDBBox>*/}
					{this.state.news_list.length > 0 &&
					<MDBBox className="news-list-section">
						<SectionHeader heading={"News"} image={NewsIcon} viewmore={true}/>
						<MDBBox className="news-section">
							<NewsList news_list={this.state.news_list}/>
						</MDBBox>
					</MDBBox>}
					{/* similare parties */}
					{
						this.state.similarPartyList.length > 0 &&
						<MDBBox className="political-party-section">
							<SectionHeader heading={"Other Political Parties"} image={PoliticalCareerIcon}
							               viewmore={false}/>
							<div className={"similar-parties-section"}>
								<PartiesList part_data={this.state.similarPartyList}/>
							</div>
						</MDBBox>
					}

					{/*<br/>*/}
					{/*<br/>*/}
					{/*<br/>*/}
					<div className={"bottom-space"}/>

					<MDBBox className="bottom-navbar" style={{marginTop: "120px"}}>
						<BottomNav/>
					</MDBBox>
				</div>
			</div>
			// </Loading>
		);
	}
}
const mapStateToProps = state => ({
	logged_in: state.UserReducer.logged_in
});

export default connect(mapStateToProps)(withRouter(PartyDetail))

